@file:OptIn(ExperimentalJsExport::class)
@file:JsExport

package components

import game.GameState
import game.gameStore
import react.useSyncExternalStore

/**
 * 订阅 Redux GameStore 的 React Hook
 */
fun useGameState(): GameState {
    return useSyncExternalStore(
        subscribe = { onChange -> gameStore.subscribe { onChange() } },
        getSnapshot = { gameStore.getState() }
    )
}
